var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouseNotes = function SvgWarehouseNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.002 3.5A6.502 6.502 0 0 0 3.5 10.002c0 .662.14 1.345.344 1.984l.003.009c.204.638.36 1.128.47 1.496.105.352.186.653.21.884.036.332.056.62.013.922-.042.303-.14.575-.266.884a3.09 3.09 0 0 1-.156.323h5.884a6.502 6.502 0 0 0 0-13.004Zm-7.87 13.33a.75.75 0 0 0 .618 1.175h7.252A8.002 8.002 0 1 0 2 10.001c0 .864.18 1.706.416 2.44.207.65.359 1.125.464 1.476.11.369.148.543.156.616.033.314.034.447.019.555-.015.108-.053.236-.171.529-.078.192-.255.466-.752 1.212Zm4.06-4.806a.75.75 0 0 1 .75-.75h6.666a.75.75 0 0 1 0 1.5H6.942a.75.75 0 0 1-.75-.75Zm.587-4.384a.75.75 0 0 0 0 1.5h6.446a.75.75 0 1 0 0-1.5H6.78Z",
    fill: "#050400"
  })));
};
export default SvgWarehouseNotes;